var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.462 20.908H6.886c-.677 0-1.227-.492-1.227-1.098V8.29c0-.607.55-1.098 1.227-1.098h10.576c.678 0 1.227.491 1.227 1.098v11.52c0 .606-.549 1.098-1.227 1.098z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.174 7.192v13.716"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.898 5.685a2.275 2.275 0 014.553 0H9.898z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.898 5.685a2.275 2.275 0 014.553 0H9.898z",
    stroke: "#666"
  }))));
}
export default SvgLift;